import { AlertCircle, Maximize2, Minimize2, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function WorkoutFormHeader({
    mode = 'create',
    client,
    formData,
    setFormData,
    validationErrors,
    isFullscreen,
    onToggleFullscreen,
    onClose,
}) {
    const { t } = useTranslation();
    const titleKey = mode === 'edit'
        ? 'gym.membersManager.workoutModal.editTitle'
        : 'gym.membersManager.workoutModal.createTitle';

    return (
        <div className="shrink-0 border-b border-gray-200 bg-white px-3 py-2 dark:border-white/10 dark:bg-gray-900 sm:px-4">
            <div className="flex flex-wrap items-end gap-2 lg:flex-nowrap lg:gap-3">
                <div className="min-w-0 shrink-0">
                    <h2 className="truncate text-sm font-bold text-gray-900 dark:text-white sm:text-base">
                        {t(titleKey)}
                    </h2>
                    <p className="truncate text-[11px] text-gray-500 dark:text-white/55">
                        {t('gym.membersManager.workoutModal.client')}:{' '}
                        <span className="font-medium text-gray-700 dark:text-white/80">
                            {client?.nome || client?.username || 'N/A'}
                        </span>
                    </p>
                </div>

                <div className="grid min-w-0 flex-1 grid-cols-1 gap-1.5 sm:grid-cols-2">
                    <div>
                        <input
                            type="text"
                            value={formData.nome}
                            onChange={(e) => setFormData((prev) => ({ ...prev, nome: e.target.value }))}
                            className={`w-full rounded-lg border px-2 py-1.5 text-xs text-gray-900 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white sm:text-sm ${
                                validationErrors.nome ? 'border-red-400' : 'border-gray-200'
                            }`}
                            placeholder={`${t('gym.membersManager.workoutModal.workoutName')} *`}
                            aria-label={t('gym.membersManager.workoutModal.workoutName')}
                        />
                        {validationErrors.nome ? (
                            <p className="mt-0.5 flex items-center text-[10px] text-red-600 dark:text-red-400">
                                <AlertCircle className="mr-1 h-3 w-3" />
                                {validationErrors.nome}
                            </p>
                        ) : null}
                    </div>
                    <input
                        type="text"
                        value={formData.descrizione}
                        onChange={(e) => setFormData((prev) => ({ ...prev, descrizione: e.target.value }))}
                        className="w-full rounded-lg border border-gray-200 px-2 py-1.5 text-xs text-gray-900 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white sm:text-sm"
                        placeholder={t('gym.membersManager.workoutModal.obiettivoPlaceholder')}
                        aria-label={t('gym.membersManager.workoutModal.obiettivo')}
                    />
                </div>

                <div className="ml-auto flex shrink-0 items-center gap-0.5">
                    <button
                        type="button"
                        onClick={onToggleFullscreen}
                        className="rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-100 dark:text-white/70 dark:hover:bg-white/10"
                        title={isFullscreen ? t('gym.membersManager.workoutModal.exitFullscreen') : t('gym.membersManager.workoutModal.fullscreen')}
                    >
                        {isFullscreen ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
                    </button>
                    <button
                        type="button"
                        onClick={onClose}
                        className="rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-100 dark:text-white/70 dark:hover:bg-white/10"
                        aria-label={t('gym.membersManager.workoutModal.cancel')}
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
}
